function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOnline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68.747,
    height: 51.193,
    viewBox: "0 0 68.747 51.193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10771"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10768"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 200",
    transform: "translate(46.919 1.75)",
    style: {
      stroke: "#91c2d8",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.5px"
    },
    d: "M0 27.824V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 201",
    transform: "translate(38.555 8.219)",
    style: {
      stroke: "#91c2d8",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.5px"
    },
    d: "M0 21.663V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 202",
    transform: "translate(30.191 13.431)",
    style: {
      stroke: "#91c2d8",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.5px"
    },
    d: "M0 16.413V0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 203",
    transform: "translate(21.827 18.707)",
    style: {
      stroke: "#91c2d8",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.5px"
    },
    d: "M0 11.137V0"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10770"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 10769"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 7456",
    d: "M1656.862 515.7v2.261a3.156 3.156 0 0 0 .251 1.206 5.153 5.153 0 0 0 4.816 3.076h55.112a5.152 5.152 0 0 0 4.816-3.076 3.132 3.132 0 0 0 .252-1.2V515.7z",
    transform: "translate(-1655.112 -472.798)",
    style: {
      stroke: "#343953",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 7457",
    d: "M1710.676 479.872h4.877v31.573h-50.093v-31.573h5",
    transform: "translate(-1656.133 -468.543)",
    style: {
      stroke: "#343953",
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "3.5px"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.f20a198e.svg";
export { ForwardRef as ReactComponent };